export class RegistrationDocument {

  federalCode: string;
  documentKind: string;
  documentCode: string;
  scholarity: string;

  constructor() {
    this.federalCode = null;
    this.documentKind = null;
    this.documentCode = null;
    this.scholarity = null;
  }

}



// WEBPACK FOOTER //
// ./src/models/registrationdocument.ts